import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";

import Balance from "./DesignEditBalance";
import Refresh from "./DesignEditRefresh";
import CopyDesign from "./DesignEditCopyDesign";

import GetDesignComponentInfo from "./DesignEditGetComponentInfo";
import GetComponents from "./DesignEditGetComponents";
import GetQuestions from "./DesignEditGetQuestions";

import AddNode from "./DesignEditAddNode";
import AddJunction from "./DesignEditAddJunction";
import AddComponent from "./DesignEditAddComponent";
import UpdateComponent from "./DesignEditUpdateComponent";

import DesignSave from "./DesignSave";
import Delete from "./DesignEditDelete";

import CalcEntryLossFactor from "./DesignEditCalcEntryLossFactor";
import CalcEntryCFM from "./DesignEditCalcEntryCFM";
import CalcDuctLoss from "./DesignEditCalcDuctLoss";
import CalcVelocity from "./DesignEditCalcVelocity";
import GetEductorMatches from "./DesignEditGetEductorMatches";
import HasEductor from "./DesignEditHasEductor";
import AddEductorSelection from "./DesignEditAddEductorSelection";
import GetEductors from "../DesignFolder/DesignFolderGetEductors";
import DeleteEductorSelection from "../DesignFolder/DesignFolderDeleteEductor";
import ChopperSelectionModal from "../Choppers/Pages/ChopperSelectionModal";
import CreateChopperDesignSelection from "../Choppers/Tools/ChoppersCreateChopperDesignSelection";
import fetchWithRetries from "../Tools/FetchWithRetries";
import GetChopperDesignSelections from "../Choppers/Tools/ChoppersGetChopperDesignSelections";
import DeleteChopperDesignSelection from "../Choppers/Tools/ChoppersDeleteChopperDesignSelection";
import ReCalculateDesign from "./DesignEditRecalculateDesign";

import { LineChart, Line, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, Legend, Label, Scatter, ScatterChart, ResponsiveContainer, ReferenceLine } from 'recharts';

const DesignEdit = () => {

    const { id } = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    //CheckToken(user["id"], user["token"]).then((result) => { if (!result) { localStorage.clear(); setUser({}); navigate("/Login") } });

    let response24 = useInvoke("WebApps", "24", null);
    let response26 = useInvoke("WebApps", "26", { "@DesignId": id });
    let response27 = useInvoke("WebApps", "27", null);
    let response29 = useInvoke("WebApps", "29", null);
    let response37 = useInvoke("WebApps", "37", null);
    let response82 = useInvoke("WebApps", "82", { "@DesignId": id });

    const [configuration, setConfiguration] = useState([]);
    const [componentCategories, setComponentCategories] = useState([]);
    const [allComponents, setAllComponents] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [categorySelection, setCategorySelection] = useState("");
    const [componentSelection, setComponentSelection] = useState({});
    const [designFolderID, setDesignFolderID] = useState("");
    const [designComponentInfo, setDesignComponentInfo] = useState([]);
    const [entryFactors, setEntryFactors] = useState([]);
    const [idPendingDelete, setIdPendingDelete] = useState("");
    const [designProjectsList, setDesignProjectsList] = useState([]);
    const [designFolderInfo, setDesignFolderInfo] = useState({});
    const [eductorInfo, setEductorInfo] = useState({});
    const [eductorMatches, setEductorMatches] = useState([]);
    const [eductorSelections, setEductorSelections] = useState([]);
    const [eductorSearch, setEductorSearch] = useState("");
    const [eductorInlet, setEductorInlet] = useState("");
    const [eductorOutlet, setEductorOutlet] = useState("");
    const [trimChoppers, setTrimChoppers] = useState([]);
    const filteredEductorMatches = eductorMatches.filter((ed) => {
        const searchValue = eductorSearch.trim().toLowerCase();
        return !searchValue || [ed.model, ed.bspr_manufacturermodel, ed.ExactResult, ed.jobnumber, ed.sketchnumber]
            .some((value) => String(value ?? "").toLowerCase().includes(searchValue));
    });

    const [isChopperSelectModalOpen, setIsChopperSelectModalOpen] = useState(false);
    const [selectedChopperComponentID, setSelectedChopperComponentID] = useState("");
    const [chopperDesignSelections, setChopperDesignSelections] = useState([]);

    useEffect(() => {

        fetchWithRetries(3, GetChopperDesignSelections, (payload) => {

            let myChopperDesignSelections = JSON.parse(payload).data;

            let chopperDesignSelectionsList = myChopperDesignSelections.map(cds => (
                {
                    "id": cds[0],
                    "ChopperID": cds[1],
                    "ComponentID": cds[2],
                    "ChopperName": cds[3],
                    "ModelName": cds[4],
                    "ModelManufacturer": cds[5]
                }
            ));

            setChopperDesignSelections(chopperDesignSelectionsList);

        });

    }, []);

    useEffect(() => {

        //Get design projects list for CopyDesign functionality
        if (response24.data.payload != undefined) {
            let data = JSON.parse(response24.data.payload).data;

            let designFolders = [];
            data.forEach((d, index) => {

                let num = d[0].toString();
                while (num.length < 6) num = "0" + num;

                designFolders.push({ "key": index, "designnum": `DP${num}`, "company": d[3], "designid": d[9], "velocity": d[12], "entrysize": d[13] });
            })
            setDesignProjectsList(designFolders);
        }

        //get components
        if (response26.data.payload != undefined) {
            processComponentData(JSON.parse(response26.data.payload).data[0]);
        }

        //get component categories
        if (response27.data.payload != undefined) {

            let data = JSON.parse(response27.data.payload).data;

            data["Categories"] = [];

            data.forEach((cat, index) => {

                data["Categories"].push({
                    key: index,
                    id: cat[0],
                    Category: cat[1]
                });
            });
            setComponentCategories(data["Categories"]);
        }

        //get all components
        if (response29.data.payload != undefined) {
            let data = JSON.parse(response29.data.payload).data;

            let componentList = [];

            data.forEach((component, index) => {

                componentList.push({
                    key: index,
                    id: component[0],
                    Component: component[1],
                    CategoryID: component[2],
                    ComponentTypeID: component[3],
                    ComponentTypeName: component[4]
                });

            });

            setAllComponents(componentList);
        }

        //get entry factors
        if (response37.data.payload != undefined) {
            let data = JSON.parse(response37.data.payload).data;

            let factors = [];
            data.forEach((factor, index) => {
                factors.push({ key: index, id: factor[1], factor: factor[1] });
            });
            setEntryFactors(factors);
        }

        //has eductor
        if (response82.data.payload != undefined) {

            processEductorInfo(JSON.parse(response82.data.payload).data[0]);

        }

    }, [response24.isPending, response26.isPending, response27.isPending, response29.isPending, response37.isPending, response82.isPending]);

    const processEductorInfo = (data) => {

        if (data[0] == "1") {
            let obj = {
                hasEductor: true,
                inletDiameter: data[1],
                outletDiameter: data[2]
            };

            setEductorInfo(obj);
            setEductorInlet(Math.ceil(parseFloat(data[1])));
            setEductorOutlet(Math.ceil(parseFloat(data[2])));
        }
        else {

            let obj = {
                hasEductor: false,
                inletDiameter: "",
                outletDiameter: ""
            };

            setEductorInfo(obj);
            setEductorInlet("");
            setEductorOutlet("");
        }

    };

    useEffect(() => {

    }, [eductorInfo]);

    useEffect(() => {
        if (designFolderID && id) {
            fetchEductorSelections();
        }
    }, [designFolderID, id]);

    useEffect(() => {

        if (designFolderID != "" && designProjectsList != []) {
            designProjectsList.forEach((df, index) => {
                if (df["designid"] == designFolderID) {
                    setDesignFolderInfo(df);
                }
            });
        }

    }, [designProjectsList]);

    //Triggers when component is selected; populates any pre-populated fields if applicable
    useEffect(() => {

        if (componentSelection.hasOwnProperty("key")) {
            let designid = id;
            let componentid = document.getElementById("ComponentId").value;

            GetQuestions(designid, componentid)
                .then((response) => {

                    let data = "";

                    if (response == undefined) {
                        toast.error("An error has occurred");
                    }
                    else {

                        data = response;

                        switch (componentSelection["ComponentTypeName"]) {

                            //Type E        
                            case "Entry Module":
                                document.getElementById("diameter").defaultValue = data["diameter"];
                                document.getElementById("velocity").defaultValue = data["velocity"];
                                document.getElementById("entryfactorId").value = data["entryFactor"];
                                document.getElementById("cfm").defaultValue = data["CFM"];
                                document.getElementById("lossfactor").defaultValue = data["lossFactor"];
                                break;

                            //Type L      
                            case "Loss Module":
                                document.getElementById("pipediameter").defaultValue = data["diameter"];
                                document.getElementById("velocitytransfer").defaultValue = data["velocity"];
                                document.getElementById("cfm").defaultValue = data["CFM"];
                                //pipe type
                                break;

                            //Type M        
                            case "Prime Mover Module":
                                document.getElementById("pathlosstomover").defaultValue = data["lossToMover"];
                                break;

                        }
                    }
                });
        }

    }, [componentSelection]);

    const processComponentData = (data) => {
        let rowsList = [];

        data["DesignNum"] = data[0];
        data["CompletedDate"] = data[1];
        data["InducedAirFlow"] = data[2];
        data["InjectedAirFlow"] = data[3];
        data["Total Discharge Air Flow"] = data[4];
        data["NegativeStaticPressure"] = data[5];
        data["BestNegativeStaticPressure"] = data[6];
        data["TotalStaticPressure"] = data[7];
        data["BestStaticPressure"] = data[8];
        data["SystemBalance"] = data[9];

        if (data[10]) { data["Notes"] = data[10]; }

        data["Components"] = [];

        if (data[11]) {
            let components = data[11].split("|");
            let lastValidCFM = null;

            components.forEach((c, index) => {
                c = c.split("‡");
                let obj = {};

                obj["key"] = index;
                obj["id"] = c[0];
                let num = c[1].toString(); while (num.length < 2) num = `0${num}`;
                obj["Item"] = num;
                obj["Type"] = c[2];
                obj["Category"] = c[3];
                obj["Component"] = c[4].replace("&amp;", "&");
                obj["Diameter"] = c[5];
                obj["Length"] = c[6];
                obj["Velocity"] = c[7];
                obj["PressureLoss"] = c[8];
                obj["CFM"] = c[9]; // This is where the CFM is initially set
                obj["Note"] = c[10].replace("&amp;", "&").replace("&gt;", ">");
                obj["ImageURL"] = "https://dc.cssi.co/Images/New/" + c[11];
                obj["prevCFM"] = lastValidCFM; //Will contain CFM of component above the current one

                if (obj["CFM"]) { lastValidCFM = obj["CFM"]; }

                let row = [
                    { type: "text", content: { text: c[1] } },
                    { type: "modalfunction", content: { text: c[2], fx: fetchDesignComponentInfo, arg: c[0], target: "#editComponent", dataid: c[0] } },
                    { type: "text", content: { text: c[3] } },
                    { type: "text", content: { text: c[4].replace("&amp;", "&") } },
                    { type: "text", content: { text: c[5] } },
                    { type: "text", content: { text: c[6] } },
                    { type: "text", content: { text: c[7] } },
                    { type: "text", content: { text: c[8] } },
                    // { type: "text", content: { text: c[9] } },
                    { type: "text", content: { text: obj["CFM"].trim() !== "" ? obj["CFM"] : lastValidCFM } },
                    { type: "text", content: { text: c[10].replace("&amp;", "&").replace("&gt;", ">") } },
                ];

                //Add a delete button if last row, else blank
                if (index == components.length - 1) {
                    row.push({ type: "modalfunction", content: { text: "Delete", fx: () => { setIdPendingDelete(c[0]) }, arg: c[0], target: "#deleteComponent", dataid: c[0] } });
                }
                else {
                    row.push({ type: "text", content: { text: "" } });
                }

                rowsList.push(row);

                data["Components"].push(obj);
            });

        }

        let num = data["12"].toString(); while (num.length < 6) num = "0" + num;
        let sequence = data["DesignNum"];
        while (sequence.length < 2) sequence = "0" + sequence;
        data["DesignFolderNum"] = `DES#${num}-${sequence}`;
        setDesignFolderID(data["13"]);
        data.splice(0, 13)
        setConfiguration(data);

        //identify all trim choppers (if any) and store in global state
        let trimChoppersList = [];
        data["Components"].forEach((component, index) => {

            if (component["Category"] == "Trim Chopper") {
                trimChoppersList.push(component);
            }
        });

        setTrimChoppers(trimChoppersList);

        setColumns(["Item", "Type", "Category", "Component", "Diameter (in)", "Length (ft)", "Velocity (fpm)", "Pressure Loss (in H2O)", "CFM", "Note", "Delete"]);
        setRows(rowsList);

        HasEductor(id)
            .then((response) => {
                if (response) {
                    let data = JSON.parse(response.payload).data[0];
                    processEductorInfo(data);
                }
                else {
                    toast.error("An error has occurred while updating eductor data.")
                }
            });

    };

    const fetchDesignComponentInfo = (id) => {

        GetDesignComponentInfo(id)
            .then((response) => {
                if (response) {
                    setDesignComponentInfo(JSON.parse(response.payload).data[0]);
                }
                else {
                    toast.error("An error has occurred.");
                }
            });
    };

    const fetchEductorMatches = (inlet = eductorInlet, outlet = eductorOutlet) => {

        if (!Number.isFinite(parseFloat(inlet)) || !Number.isFinite(parseFloat(outlet))) {
            toast.error("Enter valid inlet and outlet diameters.");
            return;
        }

        GetEductorMatches(Math.ceil(parseFloat(inlet)), Math.ceil(parseFloat(outlet)))
            .then((response) => {
                if (response.success) {

                    let matches = JSON.parse(response.payload).data;

                    let matchList = [];
                    if (matches.length > 0) {

                        matches.forEach((match, index) => {

                            let obj = {
                                "id": match[0],
                                "jobnumber": match[1],
                                "model": match[2],
                                "datecreated": match[3],
                                "datecompleted": match[4],
                                "testedbyid": match[5],
                                "approvedbyid": match[6],
                                "sketchnumber": match[7],
                                "frequency": match[8],
                                "inletdiameter": match[9],
                                "outletdiameter": match[10],
                                "horsepower": parseFloat(match[11]).toFixed(0),
                                "velocity": parseFloat(match[12]).toFixed(0),
                                "cspr_inducedairflow": parseFloat(match[13]).toFixed(0),
                                "cspr_inletstaticpressure": match[14],
                                "cspr_dischargestaticpressure": match[15],
                                "bspr_manufacturermodel": match[16],
                                "bspr_airflowcfm": parseFloat(match[17]).toFixed(0),
                                "bspr_calculatedbhp": parseFloat(match[18]).toFixed(0),
                                "bspr_inletstaticpressure": match[19],
                                "bspr_outletstaticpressure": match[20],
                                "bspr_purchaseordernumber": match[21],
                                "bspr_datecompleted": match[22],
                                "apr_plenumpressure": match[23],
                                "apr_nozzlesetting": match[24],
                                "apr_staticclosedoff": match[25],
                                "apr_tight": match[26],
                                "apr_motorrpm": parseFloat(match[27]).toFixed(0),
                                "apr_motorvoltage": parseFloat(match[28]).toFixed(0),
                                "apr_calculatedblowerairflow": match[29],
                                "apr_plenumtype": match[30],
                                "apr_motoramps1": parseFloat(match[31]).toFixed(0),
                                "apr_motoramps2": parseFloat(match[32]).toFixed(0),
                                "apr_motoramps3": parseFloat(match[33]).toFixed(0),
                                "apr_motorampsaverage": match[34],
                                "apr_motorampsrated": parseFloat(match[35]).toFixed(0),
                                "notes": match[36],
                                "tests": {},
                                "ExactResult": match[38],
                                "air_temperature": parseFloat(match[39]).toFixed(1),
                                "air_humidity": parseFloat(match[40]).toFixed(2),
                                "air_pressure": parseFloat(match[41]).toFixed(3),
                                "intakesilencer": match[42] == "False" ? 0 : 1,
                                "apr_motornotes": match[43]
                            };

                            let testList = match[37];

                            testList = testList.split("|");

                            let tests = [];
                            testList.forEach((test, index) => {
                                test = test.split("‡");

                                let sum = 0;
                                let avg = 0;
                                let count = 0;

                                let t = [
                                    Math.sqrt(parseFloat(test[5])),
                                    Math.sqrt(parseFloat(test[6])),
                                    Math.sqrt(parseFloat(test[7])),
                                    Math.sqrt(parseFloat(test[8])),
                                    Math.sqrt(parseFloat(test[9])),
                                    Math.sqrt(parseFloat(test[10])),
                                    Math.sqrt(parseFloat(test[11])),
                                    Math.sqrt(parseFloat(test[12])),
                                    Math.sqrt(parseFloat(test[13])),
                                    Math.sqrt(parseFloat(test[14])),
                                    Math.sqrt(parseFloat(test[15]))
                                ];

                                t.forEach((test1, index) => {
                                    if (test1 != 0) {
                                        sum += test1;
                                        count++;
                                    }

                                });

                                avg = (count > 0 ? sum / count : 0).toFixed(2);

                                let velocity = (parseFloat(avg) / 0.2576) * 1096;
                                let area = test[3];
                                let cfm = parseFloat(velocity) * parseFloat(area);

                                let obj = {
                                    "index": index,
                                    "percentage": test[0],
                                    "inletoutlet": test[1],
                                    "diameter": test[2],
                                    "area": test[3],
                                    "staticpressure": test[4],
                                    "vp1": test[5],
                                    "vp2": test[6],
                                    "vp3": test[7],
                                    "vp4": test[8],
                                    "vp5": test[9],
                                    "vp6": test[10],
                                    "vp7": test[11],
                                    "vp8": test[12],
                                    "vp9": test[13],
                                    "vp10": test[14],
                                    "vp11": test[15],
                                    "average": parseFloat(avg).toFixed(2),
                                    "velocity": Math.round(parseFloat(velocity)),
                                    "area": parseFloat(area).toFixed(2),
                                    "cfm": Math.round(parseFloat(cfm))
                                }

                                tests.push(obj);

                            });

                            obj["tests"] = tests;

                            matchList.push(obj);


                        });

                        matchList.sort((a, b) => {
                            // First: Exact before Approximate
                            if (a.ExactResult === "Exact" && b.ExactResult !== "Exact") return -1;
                            if (a.ExactResult !== "Exact" && b.ExactResult === "Exact") return 1;

                            // Second: inletdiameter ascending
                            const inletA = parseFloat(a.inletdiameter);
                            const inletB = parseFloat(b.inletdiameter);
                            if (inletA !== inletB) return inletA - inletB;

                            // Third: outletdiameter ascending
                            const outletA = parseFloat(a.outletdiameter);
                            const outletB = parseFloat(b.outletdiameter);
                            return outletA - outletB;
                        });

                        setEductorMatches(matchList);

                    }
                    else {
                        setEductorMatches([]);
                    }
                }
                else {
                    toast.error("An error has occurred.");
                }
            });

    };

    useEffect(() => {

    }, [eductorMatches]);

    useEffect(() => {

        switch (designComponentInfo[40]) {

            case "Loss Module":
                document.getElementById("equivalentfeetlength").value = designComponentInfo[16];
                document.getElementById("pipetype").value = designComponentInfo[17];
                document.getElementById("pipediameter").value = designComponentInfo[12];
                document.getElementById("velocitytransfer").value = designComponentInfo[13];
                document.getElementById("pressureloss").value = designComponentInfo[11];
                document.getElementById("cfm").value = designComponentInfo[15];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "Fitting":

                document.getElementById("pressureloss").value = designComponentInfo[11];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "Receiver Module":

                document.getElementById("receiverloss").value = designComponentInfo[11];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "Chopper Module":

                document.getElementById("pressureloss").value = designComponentInfo[11];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "Junction":

                document.getElementById("junctionnumber").value = designComponentInfo[22];

                break;

            case "Entry Module":

                document.getElementById("diameter").value = designComponentInfo[12];
                document.getElementById("velocity").value = designComponentInfo[13];
                document.getElementById("entryfactorId").value = designComponentInfo[14];
                document.getElementById("cfm").value = designComponentInfo[15];
                document.getElementById("lossfactor").value = designComponentInfo[11];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "Prime Mover Module":

                document.getElementById("pathlosstomover").value = designComponentInfo[60];
                document.getElementById("injectedcfm").value = designComponentInfo[15];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;

            case "New Node":

                document.getElementById("nodenumber").value = designComponentInfo[10].slice(1);

                break;

            case "Bleed In Module":

                document.getElementById("injectedaircfm").value = designComponentInfo[15];
                document.getElementById("lossinh20").value = designComponentInfo[11];
                document.getElementById("componentnotes").value = designComponentInfo[4];

                break;
        };

    }, [designComponentInfo]);

    //When adding a component, user selects a category which populates the component dropdown
    //With components of that category
    const handleCategorySelection = (e) => {

        setCategorySelection(e.target.options[e.target.selectedIndex].text);
        let categorySelection = e.target.value;
        let componentsOfType = [];

        let select = document.getElementById("ComponentId");

        allComponents.forEach((component) => {
            if (component["CategoryID"] == categorySelection) {

                // Only allow Generic Trim Chopper from 3/20/2025
                if (component["CategoryID"] == "751654de-ea41-443f-8c25-d90d75d9cbec") {
                    if (component["id"] != "60bd69da-8d3c-4adb-857d-af1417da5175") {
                        return;
                    }
                }

                componentsOfType.push(component);
            }
        });

        resetDropdownList("ComponentId");

        setComponentSelection({});

        //populate dropdown list
        componentsOfType.forEach((c, index) => {
            let option = document.createElement('option');
            option.text = c["Component"];
            option.value = c["id"];
            select.options.add(option);
        });

        if (select.options.length - 1 > 0) {
            select.disabled = false;
        }

    };

    //Store component selection in a global state
    const handleComponentSelection = (e) => {

        let componentSelectedID = e.target.value;

        allComponents.forEach((component, index) => {

            if (component["id"] == componentSelectedID) {
                setComponentSelection(component);
            }

        });
    };

    const handleUpdateComponent = (e) => {

        let designcomponentid = designComponentInfo[0];
        let designid = id;
        let userid = user["id"];
        let cfm = "";
        let diameter = "";
        let entryfactor = "";
        let length = "";
        let pressureloss = "";
        let velocity = "";
        let typeofpipe = "";
        let componentid = designComponentInfo[2];
        let notes = "";

        let itemnum = ""; //only needed for node items
        let junction = ""; //only needed for junction items

        let valid = true;

        switch (designComponentInfo[40]) {

            case "Chopper Module":
                pressureloss = document.getElementById("pressureloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Entry Module":

                if (document.getElementById("diameter").value <= 0 || document.getElementById("diameter").value == "") {
                    toast.error("Diameter cannot be 0 or less");
                    valid = false;
                }

                diameter = document.getElementById("diameter").value;
                velocity = document.getElementById("velocity").value;
                entryfactor = document.getElementById("entryfactorId").value;
                cfm = document.getElementById("cfm").value;
                pressureloss = document.getElementById("lossfactor").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Fitting":
                pressureloss = document.getElementById("pressureloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Bleed In Module":
                cfm = document.getElementById("injectedaircfm").value;
                pressureloss = document.getElementById("lossinh20").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Loss Module":

                if (document.getElementById("equivalentfeetlength").value <= 0 || document.getElementById("equivalentfeetlength").value == "") {
                    toast.error("Length cannot be 0 or less");
                    valid = false;
                }

                if (document.getElementById("pipetype").value == "") {
                    toast.error("Please select Pipe Type");
                    valid = false;
                }

                if (document.getElementById("pipediameter").value <= 0 || document.getElementById("pipediameter").value == "") {
                    toast.error("Diameter cannot be 0 or less");
                    valid = false;
                }

                length = document.getElementById("equivalentfeetlength").value;
                pressureloss = document.getElementById("pressureloss").value;
                typeofpipe = document.getElementById("pipetype").value;
                diameter = document.getElementById("pipediameter").value;
                velocity = document.getElementById("velocitytransfer").value;
                pressureloss = document.getElementById("pressureloss").value;
                cfm = document.getElementById("cfm").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Prime Mover Module":
                //pressureloss = document.getElementById("pathlosstomover").value;

                cfm = document.getElementById("injectedcfm").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Receiver Module":
                pressureloss = document.getElementById("receiverloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Junction":
                junction = document.getElementById("junctionnumber").value;
                break;

            case "New Node":
                itemnum = document.getElementById("nodenumber").value;
                break;

            default:

                toast.error("Unexpected Component Type");

        }

        if (valid) {
            UpdateComponent(designcomponentid, designid, userid, itemnum, cfm, diameter, entryfactor, length, pressureloss, velocity, typeofpipe, junction, componentid, notes)
                .then((response) => {
                    if (response == "Successfully updated component.") {

                        toast.success(response);

                        GetComponents(id).then((response) => {
                            let data = JSON.parse(response.payload).data[0];
                            processComponentData(data);

                        });

                    }

                    else {
                        toast.error(response);
                    }
                });
        }
        // else {
        //     toast.error("Please enter valid values for all required fields.");
        // }


    };

    const handleValueEdit = (elem) => {

        switch (designComponentInfo[40]) {

            case "Entry Module":

                let diameter = document.getElementById("diameter").value;
                let velocity = document.getElementById("velocity").value;
                let entryfactor = parseFloat(document.getElementById("entryfactorId").value);

                if (diameter > 0 && velocity > 0 && entryfactor > 0) {

                    switch (elem) {

                        case "diameter":
                            CalcEntryCFM(velocity, diameter)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating CFM") :
                                        document.getElementById("cfm").value = response;
                                });
                            break;

                        case "velocity":
                            CalcEntryCFM(velocity, diameter).then(response => { (response == undefined) ? toast.error("Error calculating CFM") : document.getElementById("cfm").value = response; });
                            CalcEntryLossFactor(entryfactor, velocity).then(response => { (response == undefined) ? toast.error("Error calculating Loss Factor") : document.getElementById("lossfactor").value = response; });
                            break;

                        case "entryfactor":
                            CalcEntryLossFactor(entryfactor, velocity)
                                .then(response => {
                                    (response == undefined)
                                        ? toast.error("Error calculating Loss Factor") :
                                        document.getElementById("lossfactor").value = response;
                                });
                            break;

                    }

                }

                else {
                    //toast.error("Error found in input fields")
                }

                break;

            case "Loss Module":

                let equivalentfeetlength = document.getElementById("equivalentfeetlength").value;
                let typeofpipe = document.getElementById("pipetype").value;
                let pipediameter = document.getElementById("pipediameter").value;
                let velocitytransfer = document.getElementById("velocitytransfer").value;
                let cfm = document.getElementById("cfm").value;


                if (equivalentfeetlength > 0 && typeofpipe > 0 && pipediameter > 0) {

                    switch (elem) {

                        case "equivalentfeetlength":
                            CalcDuctLoss(equivalentfeetlength, pipediameter, velocitytransfer, typeofpipe)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Duct Loss") :
                                        document.getElementById("pressureloss").value = response;
                                });
                            break;

                        case "typeofpipe":
                            CalcDuctLoss(equivalentfeetlength, pipediameter, velocitytransfer, typeofpipe)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Duct Loss") :
                                        document.getElementById("pressureloss").value = response;
                                });
                            break;

                        case "pipediameter":

                            CalcVelocity(cfm, pipediameter)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Velocity") :
                                        document.getElementById("velocitytransfer").value = response;

                                    CalcDuctLoss(equivalentfeetlength, pipediameter, response.toString(), typeofpipe)
                                        .then(response => {
                                            (response == undefined) ?
                                                toast.error("Error calculating Duct Loss") :
                                                document.getElementById("pressureloss").value = response;
                                        });

                                });

                            break;

                    }
                }

                // else {
                //     //toast.error("Error found in input fields")
                // }

                break;
        }

    };

    const handleValueChange = (elem) => {

        switch (componentSelection["ComponentTypeName"]) {

            case "Entry Module":

                let diameter = document.getElementById("diameter").value;
                let velocity = document.getElementById("velocity").value;
                let entryfactor = parseFloat(document.getElementById("entryfactorId").value);

                if (diameter > 0 && velocity > 0 && entryfactor > 0) {

                    switch (elem) {

                        case "diameter":
                            CalcEntryCFM(velocity, diameter)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating CFM") :
                                        document.getElementById("cfm").value = response;
                                });
                            break;

                        case "velocity":
                            CalcEntryCFM(velocity, diameter)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating CFM") :
                                        document.getElementById("cfm").value = response;
                                });

                            CalcEntryLossFactor(entryfactor, velocity)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Loss Factor") :
                                        document.getElementById("lossfactor").value = response;
                                });
                            break;

                        case "entryfactor":
                            CalcEntryLossFactor(entryfactor, velocity)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Loss Factor") :
                                        document.getElementById("lossfactor").value = response;
                                });
                            break;

                    }
                }

                else {
                    //toast.error("Error found in input fields")
                }

                break;

            case "Loss Module":

                let equivalentfeetlength = document.getElementById("equivalentfeetlength").value;
                let typeofpipe = document.getElementById("pipetype").value;
                let pipediameter = document.getElementById("pipediameter").value;
                let velocitytransfer = document.getElementById("velocitytransfer").value;
                let cfm = document.getElementById("cfm").value;

                if (equivalentfeetlength > 0 && typeofpipe > 0 && pipediameter > 0) {

                    switch (elem) {

                        case "equivalentfeetlength":
                            CalcDuctLoss(equivalentfeetlength, pipediameter, velocitytransfer, typeofpipe)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Duct Loss") :
                                        document.getElementById("pressureloss").value = response;
                                });
                            break;

                        case "typeofpipe":
                            CalcDuctLoss(equivalentfeetlength, pipediameter, velocitytransfer, typeofpipe)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Duct Loss") :
                                        document.getElementById("pressureloss").value = response;
                                });
                            break;

                        case "pipediameter":
                            CalcVelocity(cfm, pipediameter)
                                .then(response => {
                                    (response == undefined) ?
                                        toast.error("Error calculating Velocity") :
                                        document.getElementById("velocitytransfer").value = response;

                                    CalcDuctLoss(equivalentfeetlength, pipediameter, document.getElementById("velocitytransfer").value, typeofpipe)
                                        .then(response2 => {
                                            (response2 == undefined) ?
                                                toast.error("Error calculating Duct Loss") :
                                                document.getElementById("pressureloss").value = response2;
                                        });

                                });

                            break;

                    }

                }

                else {
                    //toast.error("Error found in input fields")
                }

                break;

        }

    };

    //Re-balance system to within 5%
    const handleBalance = (e) => {

        let toastLoading = toast.loading('Calculating...');

        Balance(id, user["id"])
            .then((response) => {

                toast.dismiss(toastLoading);

                if (response) {
                    toast.success("Balance successful.");
                    GetComponents(id)
                        .then((response) => {

                            let data = JSON.parse(response.payload).data[0];
                            processComponentData(data);

                        });
                }

                else {
                    toast.error("An error has occurred.");
                }
            });
    };

    //Revert all value changes from calculating balance
    const handleRefresh = (e) => {

        let toastLoading = toast.loading('Calculating...');

        Refresh(id)
            .then((response) => {

                toast.dismiss(toastLoading);

                if (response) {
                    toast.success("Balancing Reverted");
                    //navigate(`/DesignFolder/Details/${designFolderID}`);
                    GetComponents(id)
                        .then((response) => {

                            let data = JSON.parse(response.payload).data[0];
                            processComponentData(data);

                        });
                }

                else {
                    toast.error("An error has occurred.");
                }
            });
    };

    //Copy a design up to given node to a new design
    const handleCopy = (e) => {

        let node = document.getElementById("CopyToDesignComponentId").value;
        let copytodesignid = document.getElementById("CopyToDesignFolderId").value;

        if (node == "" || copytodesignid == "") {
            toast.error("All fields required.")
        }
        else {
            let toastLoading = toast.loading('Copying...');

            CopyDesign(id, user["id"], node, copytodesignid)
                .then((response) => {
                    toast.dismiss(toastLoading);
                    if (response.includes("Successfully copied design.")) {
                        toast.success("Successfully copied design.");
                        return response.substring(28, response.length);
                    }
                    else {
                        toast.error(response);
                        return "";
                    }

                })
                .then((newID) => {
                    if (newID.length > 0) {
                        //do nothing
                    }
                });
        }

    };

    const handleSaveNotes = (e) => {
        let notes = document.getElementById("Notes").value;
        DesignSave(id, designFolderID, notes, user["id"], "0", "");
        toast.success("Notes Saved");
    };

    //Remove a component from the design
    const handleDelete = (e, designcomponentid) => {

        Delete(designcomponentid)
            .then((response) => {
                if (response == "Successfully deleted Design Component.") {

                    toast.success(response);

                    GetComponents(id)
                        .then((response) => {

                            let data = JSON.parse(response.payload).data[0];
                            processComponentData(data);

                        });
                }
                else {
                    toast.error(response);
                }

            });
    };

    const handleAddNode = (e) => {

        let node = "";

        let input = document.getElementById("NodeNumber").value;

        //Check if input is a number
        if (isNaN(input)) {
            toast.error("Must be a number");
        }

        else {

            //Check if input is a whole number
            if (!Number.isInteger(parseFloat(input))) {
                toast.error("Must be a whole number");
            }

            else {

                //Do not allow more than 4 digits
                if (input > 9999) {
                    toast.error("Cannot exceed 4 digits");
                }

                else {

                    //Do not allow negative integars
                    if (input < 0) {
                        toast.error("Cannot be negative");
                    }

                    else {
                        node = input;
                        AddNode(user["id"], id, node)
                            .then((response) => {
                                if (response == "Successfully added node.") {

                                    toast.success("Node Added");

                                    GetComponents(id)
                                        .then((response) => {

                                            let data = JSON.parse(response.payload).data[0];
                                            processComponentData(data);

                                        });

                                }

                                else {
                                    toast.error(response);
                                }
                            });
                    }
                }
            }
        }
    };

    const handleAddJunction = (e) => {

        let input = document.getElementById("JunctionNumber").value;
        let junction = "";
        let errorMessage = "";

        if (input != "") {
            if (isNaN(input)) {
                errorMessage += "\n-Must be a number.";
            }

            if (!Number.isInteger(parseFloat(input))) {
                errorMessage += "\n-Must be a whole number.";
            }

            if (input > 9999) {
                errorMessage += "\n-Cannot exceed 4 digits.";
            }

            if (input < 0) {
                errorMessage += "\n-Must be a whole number.";
            }
        }

        if (errorMessage.length == 0) {

            if (input != "") {
                junction = input;
            }
            else {
                junction = 0;
            }


            AddJunction(user["id"], id, junction)
                .then((response) => {
                    if (response == "Successfully added Junction.") {

                        toast.success("Junction Added");

                        GetComponents(id)
                            .then((response) => {

                                let data = JSON.parse(response.payload).data[0];
                                processComponentData(data);

                            });

                    }

                    else {
                        toast.error(response);
                    }
                });
        }


    };

    const handleAddComponent = (e) => {

        let designId = id;
        let componentId = document.getElementById("ComponentId").value;
        let userId = user["id"];
        let CFM = "";
        let diameter = "";
        let entryFactor = "";
        let length = "";
        let pressureLoss = "";
        let velocity = "";
        let typeOfPipe = "";
        let notes = "";

        let valid = true;

        switch (componentSelection["ComponentTypeName"]) {

            case "Chopper Module":
                pressureLoss = document.getElementById("pressureloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Entry Module":

                if (document.getElementById("diameter").value <= 0 || document.getElementById("diameter").value == "") {
                    toast.error("Diameter cannot be 0 or less");
                    valid = false;
                }

                diameter = document.getElementById("diameter").value;
                velocity = document.getElementById("velocity").value;
                entryFactor = document.getElementById("entryfactorId").value;
                CFM = document.getElementById("cfm").value;
                pressureLoss = document.getElementById("lossfactor").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Fitting":
                pressureLoss = document.getElementById("pressureloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Bleed In Module":
                CFM = document.getElementById("injectedaircfm").value;
                pressureLoss = document.getElementById("lossinh20").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Loss Module":

                if (document.getElementById("equivalentfeetlength").value <= 0 || document.getElementById("equivalentfeetlength").value == "") {
                    toast.error("Length cannot be 0 or less");
                    valid = false;
                }

                if (document.getElementById("pipetype").value == "") {
                    toast.error("Please select Pipe Type");
                    valid = false;
                }

                if (document.getElementById("pipediameter").value <= 0 || document.getElementById("pipediameter").value == "") {
                    toast.error("Diameter cannot be 0 or less");
                    valid = false;
                }

                length = document.getElementById("equivalentfeetlength").value;
                pressureLoss = document.getElementById("pressureloss").value;
                typeOfPipe = document.getElementById("pipetype").value;
                diameter = document.getElementById("pipediameter").value;
                velocity = document.getElementById("velocitytransfer").value;
                pressureLoss = document.getElementById("pressureloss").value;
                CFM = document.getElementById("cfm").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Prime Mover Module":
                //pressureLoss = document.getElementById("pathlosstomover").value;

                CFM = document.getElementById("injectedcfm").value;
                notes = document.getElementById("componentnotes").value;
                break;

            case "Receiver Module":
                pressureLoss = document.getElementById("receiverloss").value;
                notes = document.getElementById("componentnotes").value;
                break;

            default:

                toast.error("Unexpected Component Type");

        }

        if (valid) {
            AddComponent(designId, componentId, userId, CFM, diameter, entryFactor, length, pressureLoss, velocity, typeOfPipe, notes)
                .then((response) => {
                    if (response == "Successfully added component.") {

                        toast.success(response);

                        GetComponents(id)
                            .then((response) => {

                                let data = JSON.parse(response.payload).data[0];
                                processComponentData(data);

                            });

                    }

                    else {
                        toast.error(response);
                    }
                });
        }


    };

    //Lock the design for editing
    const handleFinalize = (e) => {

        let notes = document.getElementById("Notes").value;

        DesignSave(id, designFolderID, notes, user["id"], "0", (new Date()).toLocaleDateString('en-US'))
            .then((response) => {

                GetComponents(id)
                    .then((response) => {

                        let data = JSON.parse(response.payload).data[0];
                        processComponentData(data);

                    });
            });

    };

    const fetchEductorSelections = () => {
        GetEductors(designFolderID)
            .then((response) => {
                if (!response?.success) {
                    toast.error("Unable to load eductor selections.");
                    return;
                }

                const normalizeId = (value) => String(value ?? "").trim().replace(/[{}]/g, "").toLowerCase();
                const selections = JSON.parse(response.payload).data
                    .filter((eductor) => normalizeId(eductor[2]) === normalizeId(id))
                    .map((eductor, index) => {
                        const createdDate = new Date(eductor[4]);

                        return {
                            key: index,
                            id: eductor[0],
                            name: eductor[1],
                            designid: eductor[2],
                            designnum: eductor[3],
                            createddate: Number.isNaN(createdDate.getTime()) ? "" : createdDate.toLocaleDateString("en-US")
                        };
                    });

                setEductorSelections(selections);
            });
    };

    const handleAttachEductor = (e, eductorid) => {

        AddEductorSelection(eductorid, id)
            .then((response) => {

                if (response.success) {
                    toast.success("Eductor Selection has been attached to this design");
                    fetchEductorSelections();
                }
                else {
                    toast.error("Failed to attach Eductor Selection to this design.");
                }

            })

    };

    const handleUnselectEductor = (eductor) => {
        DeleteEductorSelection(eductor.id, eductor.designid)
            .then((response) => {
                if (response.success) {
                    toast.success("Eductor selection has been removed from this design.");
                    setEductorSelections((currentSelections) => currentSelections.filter((selection) => selection.id !== eductor.id));
                }
                else {
                    toast.error("Failed to remove eductor selection.");
                }
            });
    };

    const clearElements = (e) => {

        setCategorySelection("");
        setComponentSelection({});

        const inputs = document.querySelectorAll("input, select");
        inputs.forEach(input => {
            input.value = "";
        });
    }

    //Remove all options from dropdown list but leave default
    const resetDropdownList = (targetID) => {
        let select = document.getElementById(targetID);
        for (let i = select.options.length - 1; i > 0; i--) {
            select.remove(i);
        }
    };

    const handleOpenChopperModal = (componentID) => {
        setSelectedChopperComponentID(componentID);
        setIsChopperSelectModalOpen(true);
    };

    const handleAssignChopper = (selection, componentID) => {

        if (selection && componentID) {
            CreateChopperDesignSelection(selection.ChopperID, componentID)
                .then((response) => {
                    if (response.success) {
                        toast.success("Chopper Selection has been assigned to this design component");

                        fetchWithRetries(3, GetChopperDesignSelections, (payload) => {

                            let myChopperDesignSelections = JSON.parse(payload).data;

                            let chopperDesignSelectionsList = myChopperDesignSelections.map(cds => (
                                {
                                    "id": cds[0],
                                    "ChopperID": cds[1],
                                    "ComponentID": cds[2],
                                    "ChopperName": cds[3],
                                    "ModelName": cds[4],
                                    "ModelManufacturer": cds[5]
                                }
                            ));

                            setChopperDesignSelections(chopperDesignSelectionsList);
                            setSelectedChopperComponentID(null);
                            setIsChopperSelectModalOpen(false);

                        });

                    }
                    else {
                        toast.error("Failed to assign Chopper Selection to this design component.");
                    }
                });

        };
    };

    const handleUnassignChopper = (componentID) => {

        if (!componentID) { return; }

        // iterate over chopperDesignSelections to find the matching selection
        const selectionToDelete = chopperDesignSelections.find(selection => selection.ComponentID === componentID);
        if (!selectionToDelete) { return; }
        const chopperDesignSelectionID = selectionToDelete.id;

        DeleteChopperDesignSelection(chopperDesignSelectionID)
            .then((response) => {
                if (response.success) {
                    toast.success("Chopper Selection has been unassigned from this design component");

                    // Remove the chopper selection from the state array
                    setChopperDesignSelections(prevSelections => prevSelections.filter(selection => selection.id !== chopperDesignSelectionID));

                    // fetchWithRetries(3, GetChopperDesignSelections, (payload) => {

                    //     let myChopperDesignSelections = JSON.parse(payload).data;

                    //     let chopperDesignSelectionsList = myChopperDesignSelections.map(cds => (
                    //         {
                    //             "id": cds[0],
                    //             "ChopperID": cds[1],
                    //             "ComponentID": cds[2]
                    //         }
                    //     ));

                    //     setChopperDesignSelections(chopperDesignSelectionsList);

                    // });
                }
                else {
                    toast.error("Failed to unassign Chopper Selection from this design component.");
                }
            });

    };

    const handleRecalculation = () => {

        ReCalculateDesign(id)
            .then((response) => {
                if (response) {
                    toast.success("Recalculation successful.");

                    GetComponents(id)
                        .then((response) => {
                            let data = JSON.parse(response.payload).data[0];
                            processComponentData(data);
                        });
                }
                else {
                    toast.error(response);
                }
            });

    };

    const PerformanceGraphDE = (props) => {

        let input = props.input;
        let eductor = props.eductor;
        let configuration = props.config;

        if (!input) {
            console.log("An error has occurred.");
            return -1;
        };

        let breakpoint = "";
        let points = [];
        let graphPoints = [];
        let sortedPoints = [];
        let p = [];
        let r = [];
        let data01 = [];
        let data02 = [];

        if (input !== undefined && input.length !== 0 && eductor["cspr_inducedairflow"] !== undefined) {
            input.forEach((item, index) => {
                if (item["inletoutlet"] == "0" && item["percentage"] != 0) {

                    // points.push({ "x": item["cfm"], "y": Math.abs(parseFloat(item["staticpressure"])) });
                    points.push({ "x": parseFloat(item["cfm"]), "y": Math.abs(parseFloat(item["staticpressure"])) });


                }
            });

            sortedPoints = points.sort((a, b) => a.x - b.x);

            data01 = [
                { x: 0, y: Math.abs(parseFloat(eductor["apr_staticclosedoff"])) || 0 },
                { x: sortedPoints[0]?.x || 0, y: sortedPoints[0]?.y || 0 },
                { x: sortedPoints[1]?.x || 0, y: sortedPoints[1]?.y || 0 },
                { x: sortedPoints[2]?.x || 0, y: sortedPoints[2]?.y || 0 },
                { x: sortedPoints[3]?.x || 0, y: sortedPoints[3]?.y || 0 }
            ];

            data02 = [
                // { x: parseFloat(eductor["cspr_inducedairflow"]), y: Math.abs(parseFloat(eductor["cspr_inletstaticpressure"])) + Math.abs(parseFloat(eductor["cspr_dischargestaticpressure"])) }
                //{ x: parseFloat(eductor["cspr_inducedairflow"]), y: parseFloat(configuration["TotalStaticPressure"]).toFixed(3) }
                { x: parseFloat(configuration["InducedAirFlow"]), y: parseFloat(configuration["TotalStaticPressure"]).toFixed(3) }
            ];
        };

        return (
            <div style={{ width: "100%" }}>
                <ResponsiveContainer width="100%" height={300}>
                    <ScatterChart
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 0,
                        }}
                    >
                        <CartesianGrid />
                        <XAxis type="number" dataKey="x" name="cfm" label={{ value: "CFM", position: "insideBottomRight", dy: 25, dx: 10 }} />
                        <YAxis type="number" dataKey="y" name="sp" label={{ value: "Static Pressure", position: "insideBottomRight", dy: -200, dx: -32, angle: -90 }} />
                        <ZAxis type="number" range={[100]} />
                        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                        <Legend />
                        <ReferenceLine x={parseFloat(configuration["InducedAirFlow"])} stroke="var(--bs-red)" />
                        <ReferenceLine y={parseFloat(configuration["TotalStaticPressure"]).toFixed(3)} stroke="var(--bs-red)" />
                        <Scatter name="Test Points" data={data01} fill="black" line shape="square" />
                        <Scatter name="Performance Requirement (This Design Configuration)" data={data02} fill="var(--bs-red)" line shape="cross" />

                    </ScatterChart>
                </ResponsiveContainer>
            </div>
        );
    };

    document.title = "Design - Edit";
    return (
        <div className="designedit" style={{ width: "1280px", margin: "auto" }}>

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px" }}>

                        {configuration["CompletedDate"] == null &&
                            <>
                                <h2 style={{ marginTop: "-15px" }}>{configuration["DesignFolderNum"]} (in process)</h2>
                            </>
                        }

                        {configuration["CompletedDate"] != null &&
                            <>
                                <h2 style={{ marginTop: "-15px" }}>{configuration["DesignFolderNum"]}<b> (Finalized)</b></h2>
                            </>
                        }

                        {/* Top Row Buttons */}
                        <>
                            {configuration["CompletedDate"] == null &&
                                <div style={{ marginBottom: "8px" }}>


                                    <Link className="btn btn-primary" to={`/Design/Print/${id}`} style={{ float: "right", marginLeft: "8px" }} id="btnPrintDesign">Print</Link>
                                    <Link to={`/Schematic/Draw/${id}`} className="btn btn-primary" style={{ float: "right", marginLeft: "8px" }}>Schematic</Link>
                                    <button className="btn btn-secondary" onClick={handleRecalculation} id="btnRecalculate" style={{ float: "right", marginLeft: "8px" }}>Re-calculate</button>

                                    <button className="btn btn-primary" style={{ margin: "0px 0px", width: "136px" }} data-bs-toggle="modal" data-bs-target="#newComponent">Add Component</button>
                                    <button className="btn btn-primary" style={{ margin: "0px 4px", width: "136px" }} data-bs-toggle="modal" data-bs-target="#newNode" id="btnAddNode">Add Node</button>
                                    <button className="btn btn-primary" style={{ margin: "0px 4px", width: "136px" }} data-bs-toggle="modal" data-bs-target="#newJunction" id="btnAddJunction">Add Junction</button>
                                </div>
                            }

                        </>

                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={false} defaultsortindex={0} />}

                        {/* Air Pro Fan Modal */}
                        <div className="modal" id="airprofan" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content" style={{ width: "1366px", position: "fixed", left: "24px" }}>
                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">Air Pro Fan</h4></div>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>

                                    </div>

                                    <div className="modal-body">
                                        <div className="accordion" id="accordion_DesignInfo" style={{ fontSize: "14px", width: "1208px", marginBottom: "8px" }}>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button btn-primary" style={{ width: "1208px", marginTop: "-20px", fontSize: "14px" }} type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        Design Info
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion_DesignInfo">
                                                    <div className="accordion-body">
                                                        <table className="table table-bordered table-hover dataTable" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Induced Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InducedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Injected Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InjectedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Total Discharge Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["Total Discharge Air Flow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Negative Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["NegativeStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestNegativeStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Total Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["TotalStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Balance:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* {window.open("https://my.airprofan.com/login.aspx", "_blank")} */}
                                        {/* <iframe src="https://my.airprofan.com/login.aspx" height="720" width="1280" title="Iframe Example"></iframe> */}

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* New York Blower Modal */}
                        <div className="modal" id="newyorkblower" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content" style={{ width: "1366px", position: "fixed", left: "24px" }}>
                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">New York Blower</h4></div>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>

                                    </div>

                                    <div className="modal-body">
                                        <div className="accordion" id="accordion_DesignInfo" style={{ fontSize: "14px", width: "1208px", marginBottom: "8px" }}>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button btn-primary" style={{ width: "1208px", marginTop: "-20px", fontSize: "14px" }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Design Info</button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion_DesignInfo">
                                                    <div className="accordion-body">
                                                        <table className="table table-bordered table-hover dataTable" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Induced Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InducedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Injected Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InjectedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Total Discharge Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["Total Discharge Air Flow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Negative Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["NegativeStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestNegativeStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Total Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["TotalStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Balance:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <iframe src="https://apps.nyb.com/FanToSize/ProductSelection.aspx" height="720" width="1280" title="Iframe Example"></iframe> */}

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* IAT Modal */}
                        <div className="modal" id="iat" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content" style={{ width: "1366px", position: "fixed", left: "24px" }}>
                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">IAT</h4></div>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>

                                    </div>

                                    <div className="modal-body">
                                        <div className="accordion" id="accordion_DesignInfo" style={{ fontSize: "14px", width: "1208px", marginBottom: "8px" }}>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button btn-primary" style={{ width: "1208px", marginTop: "-20px", fontSize: "14px" }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Design Info</button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion_DesignInfo">
                                                    <div className="accordion-body">
                                                        <table className="table table-bordered table-hover dataTable" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Induced Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InducedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Injected Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InjectedAirFlow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Total Discharge Air Flow:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["Total Discharge Air Flow"]).toFixed(0)}</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Negative Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["NegativeStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestNegativeStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Total Static Pressure:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["TotalStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Balance:</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</td>
                                                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* {window.open("https://my.airprofan.com/login.aspx", "_blank")} */}
                                        {/* <iframe src="https://my.airprofan.com/login.aspx" height="720" width="1280" title="Iframe Example"></iframe> */}

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* New Component Modal */}
                        <div className="modal" id="newComponent" tabIndex="-1" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">Add Component</h4></div>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>

                                    </div>

                                    <div className="modal-body">

                                        <form id="designComponentForm" noValidate="noValidate" autoComplete="off">
                                            <div className="form-group">

                                                <label htmlFor="ComponentCategoryId">Component Category</label>

                                                <select className="form-control" id="ComponentCategoryId" name="ComponentCategoryId" style={{ width: "400px" }}
                                                    onChange={(e) => { handleCategorySelection(e) }}>
                                                    <option value="">Select Category</option>

                                                    {componentCategories && componentCategories.map((cc, i1) => (
                                                        <option key={i1} value={cc["id"]}>
                                                            {cc["Category"]}
                                                        </option>
                                                    ))}

                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="ComponentId">Component</label>
                                                <select className="form-control" id="ComponentId" name="ComponentId" style={{ width: "400px", marginRight: "5px" }}
                                                    onChange={(e) => { handleComponentSelection(e) }}>
                                                    <option value="">Select Component</option>
                                                </select>
                                            </div>

                                            {/* //Type C */}
                                            {componentSelection["ComponentTypeName"] == "Chopper Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" id="pressureloss" name="pressureloss" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type E */}
                                            {componentSelection["ComponentTypeName"] == "Entry Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="diameter">Diameter (in)</label>
                                                        <input onChange={() => { handleValueChange("diameter") }} className="form-control valid" id="diameter" name="diameter" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="velocity">Velocity (fpm)</label>
                                                        <input onChange={() => { handleValueChange("velocity") }} className="form-control valid" id="velocity" name="velocity" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="entryfactorId">Entry Factor</label>
                                                        <select onChange={() => { handleValueChange("entryfactor") }} className="form-control" id="entryfactorId" name="entryfactorId" style={{ width: "400px", marginRight: "5px" }}>
                                                            <option value="">Select Entry Factor</option>
                                                            {entryFactors && entryFactors.map((ef, i2) => (<option key={i2} value={ef.id}>{ef.factor}</option>))}
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="cfm">CFM</label>
                                                        <input className="form-control valid" readOnly={true} id="cfm" name="cfm" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="lossfactor">Loss Factor</label>
                                                        <input className="form-control valid" readOnly={true} id="lossfactor" name="lossfactor" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type F */}
                                            {componentSelection["ComponentTypeName"] == "Fitting" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" id="pressureloss" name="pressureloss" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type I */}
                                            {componentSelection["ComponentTypeName"] == "Bleed In Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="injectedaircfm">Injected Air CFM</label>
                                                        <input className="form-control valid" id="injectedaircfm" name="injectedaircfm" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="lossinh20">Loss in H2O</label>
                                                        <input className="form-control valid" id="lossinh20" name="lossinh20" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type J */}
                                            {componentSelection["ComponentTypeName"] == "Junction" &&
                                                <>

                                                </>
                                            }

                                            {/* //Type L */}
                                            {componentSelection["ComponentTypeName"] == "Loss Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="equivalentfeetlength">Equivalent Feet Length</label>
                                                        <input onChange={() => { handleValueChange("equivalentfeetlength") }} className="form-control valid" id="equivalentfeetlength" name="equivalentfeetlength" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pipetype">Type of Pipe</label>
                                                        <select onChange={() => { handleValueChange("typeofpipe") }} className="form-control" id="pipetype" name="pipetype" defaultValue="2" style={{ width: "400px", marginRight: "5px" }}>
                                                            <option value="">Select Type</option>
                                                            <option value="1">Rough</option>
                                                            <option value="2">Smooth</option>
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pipediameter">Pipe Diameter (in)</label>
                                                        <input onChange={() => { handleValueChange("pipediameter") }} className="form-control valid" id="pipediameter" name="pipediameter" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="velocitytransfer">Velocity Transfer (fpm)</label>
                                                        <input className="form-control valid" readOnly={true} id="velocitytransfer" name="velocitytransfer" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" readOnly={true} id="pressureloss" name="pressureloss" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="cfm">CFM</label>
                                                        <input className="form-control valid" readOnly={true} id="cfm" name="cfm" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type M */}
                                            {componentSelection["ComponentTypeName"] == "Prime Mover Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pathlosstomover">Path Loss to Mover</label>
                                                        <input className="form-control valid" readOnly={true} id="pathlosstomover" name="pathlosstomover" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="injectedcfm">Injected CFM</label>
                                                        <input className="form-control valid" id="injectedcfm" name="injectedcfm" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                            {/* //Type N */}
                                            {componentSelection["ComponentTypeName"] == "New Node" &&
                                                <>

                                                </>
                                            }

                                            {/* //Type R */}
                                            {componentSelection["ComponentTypeName"] == "Receiver Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="receiverloss">Receiver Loss (in H2O)</label>
                                                        <input className="form-control valid" id="receiverloss" name="receiverloss" type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>
                                                    <button onClick={(e) => { handleAddComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                                                </>
                                            }

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Edit Component Modal */}
                        <div className="modal" id="editComponent" tabIndex="-1" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static" dataid={designComponentInfo[0]}>
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: "24px" }}>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>
                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">Edit Component</h4></div>
                                    </div>

                                    <div className="modal-body">

                                        <form id="editDesignComponentForm" noValidate="noValidate" autoComplete="off">

                                            {/* //Type C */}
                                            {designComponentInfo[40] == "Chopper Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" id="pressureloss" name="pressureloss" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type E */}
                                            {designComponentInfo[40] == "Entry Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="diameter">Diameter (in)</label>
                                                        <input onChange={() => { handleValueEdit("diameter") }} className="form-control valid" id="diameter" name="diameter" type="text" defaultValue={designComponentInfo[12]}></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="velocity">Velocity (fpm)</label>
                                                        <input onChange={() => { handleValueEdit("velocity") }} className="form-control valid" id="velocity" name="velocity" defaultValue={designComponentInfo[13]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="entryfactorId">Entry Factor</label>
                                                        <select onChange={() => { handleValueEdit("entryfactor") }} className="form-control" id="entryfactorId" name="entryfactorId" defaultValue={designComponentInfo[14]} style={{ width: "400px", marginRight: "5px" }}>
                                                            <option value="">Select Entry Factor</option>
                                                            {entryFactors && entryFactors.map((ef, i3) => (<option key={i3} value={ef.id}>{ef.factor}</option>))}
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="cfm">CFM</label>
                                                        <input className="form-control valid" readOnly={true} id="cfm" name="cfm" defaultValue={designComponentInfo[15]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="lossfactor">Loss Factor</label>
                                                        <input className="form-control valid" readOnly={true} id="lossfactor" name="lossfactor" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type F */}
                                            {designComponentInfo[40] == "Fitting" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" id="pressureloss" name="pressureloss" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type I */}
                                            {designComponentInfo[40] == "Bleed In Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="injectedaircfm">Injected Air CFM</label>
                                                        <input className="form-control valid" id="injectedaircfm" name="injectedaircfm" defaultValue={designComponentInfo[15]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="lossinh20">Loss in H2O</label>
                                                        <input className="form-control valid" id="lossinh20" name="lossinh20" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type J */}
                                            {designComponentInfo[40] == "Junction" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="junctionnumber">What is the next junction this point connects to (number only)? (If last junction, leave blank.)</label>
                                                        <input className="form-control valid" id="junctionnumber" name="junctionnumber" defaultValue={designComponentInfo[22]} type="text"></input>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type L */}
                                            {designComponentInfo[40] == "Loss Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="equivalentfeetlength">Equivalent Feet Length</label>
                                                        <input onChange={() => { handleValueEdit("equivalentfeetlength") }} className="form-control valid" id="equivalentfeetlength" name="equivalentfeetlength" defaultValue={designComponentInfo[16]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pipetype">Type of Pipe</label>
                                                        <select onChange={() => { handleValueEdit("typeofpipe") }} className="form-control" id="pipetype" name="pipetype" defaultValue={designComponentInfo[17]} style={{ width: "400px", marginRight: "5px" }}>
                                                            <option value="">Select Type</option>
                                                            <option value="1">Rough</option>
                                                            <option value="2">Smooth</option>
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pipediameter">Pipe Diameter (in)</label>
                                                        <input onChange={() => { handleValueEdit("pipediameter") }} className="form-control valid" id="pipediameter" name="pipediameter" defaultValue={designComponentInfo[12]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="velocitytransfer">Velocity Transfer (fpm)</label>
                                                        <input className="form-control valid" readOnly={true} id="velocitytransfer" name="velocitytransfer" defaultValue={designComponentInfo[13]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="pressureloss">Pressure Loss (in H2O)</label>
                                                        <input className="form-control valid" readOnly={true} id="pressureloss" name="pressureloss" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="cfm">CFM</label>
                                                        <input className="form-control valid" readOnly={true} id="cfm" name="cfm" defaultValue={designComponentInfo[15]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type M */}
                                            {designComponentInfo[40] == "Prime Mover Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="pathlosstomover">Path Loss to Mover</label>
                                                        <input className="form-control valid" readOnly={true} id="pathlosstomover" name="pathlosstomover" defaultValue={designComponentInfo[60]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="injectedcfm">Injected CFM</label>
                                                        <input className="form-control valid" id="injectedcfm" name="injectedcfm" defaultValue={designComponentInfo[15]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type N */}
                                            {designComponentInfo[40] == "New Node" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="nodenumber">Node Number (number only)</label>
                                                        <input className="form-control valid" id="nodenumber" name="nodenumber" defaultValue={designComponentInfo[10].slice(1)} type="text"></input>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                            {/* //Type R */}
                                            {designComponentInfo[40] == "Receiver Module" &&
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="receiverloss">Receiver Loss (in H2O)</label>
                                                        <input className="form-control valid" id="receiverloss" name="receiverloss" defaultValue={designComponentInfo[11]} type="text"></input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="componentnotes">Node Notes</label>
                                                        <textarea className="form-control" cols="20" id="componentnotes" name="componentnotes" defaultValue={designComponentInfo[4]} rows="2" style={{ width: "400px", height: "100px" }}></textarea>
                                                    </div>

                                                    <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                                    {configuration["CompletedDate"] == null &&
                                                        <>
                                                            <button onClick={(e) => { handleUpdateComponent(e) }} style={{ marginLeft: "8px" }} type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                                        </>
                                                    }

                                                </>
                                            }

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Delete Component Modal */}
                        <div className="modal" id="deleteComponent" tabIndex="-1" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: "24px" }}>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>
                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="editComponentLabel">Confirm Delete</h4></div>
                                    </div>
                                    <div className="modal-body">

                                        {configuration["CompletedDate"] == null &&
                                            <div className="bootbox-body">Are you sure you want to delete this design component?</div>
                                        }

                                        {configuration["CompletedDate"] != null &&
                                            <div className="bootbox-body">Modification unavailable once design has been finalized</div>
                                        }

                                    </div>
                                    <div className="modal-footer">

                                        <button onClick={clearElements} id="dismissbtn" data-bb-handler="cancel" data-bs-dismiss="modal" type="button" className="btn btn-default">Cancel</button>

                                        {configuration["CompletedDate"] == null &&
                                            <>
                                                <button onClick={(e) => { handleDelete(e, idPendingDelete) }} type="button" className="btn btn-danger" data-bs-dismiss="modal">Yes</button>
                                            </>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Data Table */}
                        <table className="table table-bordered table-hover dataTable" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Induced Air Flow:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InducedAirFlow"]).toFixed(0)}</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Injected Air Flow:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["InjectedAirFlow"]).toFixed(0)}</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>Total Discharge Air Flow:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["Total Discharge Air Flow"]).toFixed(0)}</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Negative Static Pressure:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["NegativeStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestNegativeStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Total Static Pressure:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["TotalStaticPressure"]).toFixed(3)}&nbsp;(longest run)</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>{parseFloat(configuration["BestStaticPressure"]).toFixed(3)}&nbsp;(shortest run)</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right", padding: "8px 50px 8px 8px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>System Balance:</td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}>
                                        {parseFloat(configuration["SystemBalance"]).toFixed(3) >= 5 ?
                                            <span style={{ color: "var(--bs-danger)" }}>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</span> :
                                            <span>{parseFloat(configuration["SystemBalance"]).toFixed(3)}%</span>
                                        }
                                    </td>
                                    <td style={{ textAlign: "left", padding: "8px", paddingRight: "50px", width: "33%", fontWeight: "bold", border: "1px solid #eeeeee" }}></td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                            {/* Notes */}
                            {configuration["Notes"] && <div>
                                <textarea className="form-control designNotes" cols="20" id="Notes" name="Notes" rows="2" style={{ minWidth: "100%", height: "75px", marginTop: "20px" }} defaultValue={configuration["Notes"]}
                                    onBlur={handleSaveNotes}
                                ></textarea>
                            </div>}

                            {!configuration["Notes"] && <div>
                                <textarea className="form-control designNotes" cols="20" id="Notes" name="Notes" rows="2" style={{ minWidth: "100%", height: "75px", marginTop: "20px" }} placeholder={"Design Notes..."}
                                    onBlur={handleSaveNotes}
                                ></textarea>
                            </div>}
                        </div>

                        <div className="card" style={{ marginTop: "20px", marginBottom: "20px" }}>
                            <div className="card-header">
                                <h5 className="card-title">Trim Choppers - Specify Models in System</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-bordered table-hover table-striped" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Item #</th>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Type</th>
                                            <th style={{ textAlign: "left", verticalAlign: "middle", width: "35%" }}>Node Notes</th>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Pressure Loss</th>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Chopper Selection</th>
                                            <th style={{ textAlign: "center", verticalAlign: "middle" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {trimChoppers.map((item, i) => (
                                            <tr key={i}>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item["Item"]}</td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item["Type"]}</td>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>{item["Note"]}</td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item["PressureLoss"]}</td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>

                                                    {chopperDesignSelections
                                                        .filter(chopper => item["id"] == chopper["ComponentID"]) // Only process relevant items
                                                        .map((chopper, w) => (
                                                            <div key={w} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "2px" }}>
                                                                <Link to={`/Choppers/Details/${chopper["ChopperID"]}`} style={{ fontWeight: "bold", color: "var(--bs-primary)" }}>
                                                                    {chopper["ChopperName"]}
                                                                </Link>
                                                                <span>
                                                                    ({chopper["ModelManufacturer"]} {chopper["ModelName"]})
                                                                </span>
                                                            </div>
                                                        ))
                                                    }


                                                    {/* If none, say "Unassigned" in italics red */}
                                                    {chopperDesignSelections.every(chopper => item["id"] != chopper["ComponentID"]) ? <span style={{ fontStyle: "italic", color: "var(--bs-secondary)" }}>Unassigned</span> : <></>
                                                    }


                                                </td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle", margin: "2px", height: "64px" }}>

                                                    {chopperDesignSelections.some(chopper => item["id"] == chopper["ComponentID"]) ? (
                                                        <button className="btn btn-outline-danger" style={{ width: "96px", marginTop: "10px", margin: "0px 4px", border: "1px solid" }} onClick={() => handleUnassignChopper(item.id)}>Un-register</button>
                                                    ) : (
                                                        <button className="btn btn-primary" style={{ width: "96px", marginTop: "10px", margin: "0px 4px"}} onClick={() => handleOpenChopperModal(item.id)}>Register</button>
                                                    )}

                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="card" style={{ marginTop: "20px", marginBottom: "20px" }}>
                            <div className="card-header">
                                <h5 className="card-title">Eductor Selections</h5>
                            </div>
                            <div className="card-body">
                                {eductorSelections.length > 0 ? (
                                    <table className="table table-bordered table-hover table-striped" style={{ marginLeft: "0px", border: "1px solid #eeeeee" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ textAlign: "left", verticalAlign: "middle" }}>Eductor</th>
                                                <th style={{ textAlign: "center", verticalAlign: "middle" }}>Selected</th>
                                                <th style={{ textAlign: "center", verticalAlign: "middle" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {eductorSelections.map((eductor) => (
                                                <tr key={eductor.id}>
                                                    <td style={{ verticalAlign: "middle", fontWeight: "bold" }}>{eductor.name}</td>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{eductor.createddate || "-"}</td>
                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            style={{ width: "96px", border: "1px solid" }}
                                                            onClick={() => handleUnselectEductor(eductor)}
                                                        >
                                                            Un-select
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <span style={{ fontStyle: "italic", color: "var(--bs-secondary)" }}>No eductors selected for this design.</span>
                                )}
                            </div>
                        </div>

                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>

                            <div>
                                <Link to={`/DesignFolder/Details/${designFolderID}`} className="btn btn-default" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}>
                                    Back
                                </Link>
                            </div>

                            <button className="btn btn-primary" id="btnSaveNotes" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                onClick={handleSaveNotes}
                            >
                                Save Notes
                            </button>

                            <div>
                                {configuration["CompletedDate"] == null &&
                                    <>
                                        <button className="btn btn-warning" id="btnReset" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                            onClick={handleFinalize}
                                        >
                                            Finalize
                                        </button>

                                        <span
                                            data-tooltip-id={!eductorInfo["hasEductor"] ? "eductor-requirements-tooltip" : undefined}
                                            style={{ display: "inline-block" }}
                                        >
                                            <button
                                                className={`btn ${!eductorInfo["hasEductor"] ? "btn-secondary" : "btn-primary"}`}
                                                id="btnEductors"
                                                style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                                onClick={() => { fetchEductorMatches() }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#eductorResults"
                                                disabled={!eductorInfo["hasEductor"]}
                                            >
                                                Eductors
                                            </button>
                                        </span>

                                        {!eductorInfo["hasEductor"] && (
                                            <ReactTooltip id="eductor-requirements-tooltip" place="top">
                                                <div>
                                                    <strong>To specify an eductor, system must contain:</strong>
                                                    <ul style={{ margin: "4px 0 0", paddingLeft: "18px" }}>
                                                        <li>An eductor inlet duct.</li>
                                                        <li>A valid eductor body.</li>
                                                        <li>An eductor outlet duct.</li>
                                                    </ul>
                                                </div>
                                            </ReactTooltip>
                                        )}

                                        <button className="btn btn-primary" id="btnCopyDesign" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                            data-bs-toggle="modal" data-bs-target="#copyDesign"
                                        >
                                            Copy Design
                                        </button>
                                    </>
                                }
                            </div>

                            <div>
                                <button className="btn btn-info" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                    onClick={() => window.open("https://my.airprofan.com/login.aspx", "_blank", "width=1280px, height=768px")} data-bs-toggle="modal" data-bs-target="#airprofan"
                                >
                                    Air Pro Fan
                                </button>

                                <button className="btn btn-info" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                    onClick={() => window.open("https://apps.nyb.com/FanToSize/ProductSelection.aspx", "_blank", "width=1280px, height=768px")} data-bs-toggle="modal" data-bs-target="#newyorkblower"
                                >
                                    New York Blower
                                </button>

                                <button className="btn btn-info" style={{ marginTop: "10px", margin: "0px 4px", width: "auto" }}
                                    onClick={() => window.open("http://www.myelements.co/Titanium/Account/Login2.aspx?ReturnUrl=/Titanium?division=iat&division=iat", "_blank", "width=1280px, height=768px")} data-bs-toggle="modal" data-bs-target="#iat"
                                >
                                    IAT
                                </button>
                            </div>

                            <div>
                                {configuration["CompletedDate"] == null
                                    ? (
                                        <>
                                            <button className="btn btn-success" onClick={handleBalance} id="btnBalance" style={{ marginTop: "10px", margin: "0px 4px", width: "136px" }}>Balance</button>
                                            <button className="btn btn-danger" onClick={handleRefresh} id="btnReset" style={{ marginTop: "10px", margin: "0px 4px", width: "136px" }}>Revert Balance</button>
                                        </>
                                    )
                                    : (
                                        <>
                                            <Link className="btn btn-primary" to={`/Design/Print/${id}`} style={{ marginTop: "10px", margin: "0px 4px", width: "136px" }} id="btnPrintDesign">Print</Link>
                                            <Link to={`/Schematic/Draw/${id}`} className="btn btn-primary" style={{ marginTop: "10px", margin: "0px 0px", width: "136px" }}>Schematic</Link>
                                        </>
                                    )
                                }
                            </div>

                        </div>

                        {/* New Junction Modal */}
                        <div className="modal" id="newJunction" tabIndex="-1" role="dialog" aria-labelledby="addJunctionLabel" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: "24px" }}>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>
                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addJunctionLabel">Add Junction</h4></div>
                                    </div>

                                    <div className="modal-body">

                                        <form id="newJunctionForm" noValidate="noValidate" autoComplete="off">
                                            <div className="form-group">
                                                What is the next junction this point connects to (number only). If last junction, leave blank.
                                                <input type="number" min="0" className="form-control" id="JunctionNumber" name="JunctionNumber" autoComplete="off" />
                                            </div>

                                        </form>
                                        <button onClick={clearElements} type="button" style={{ margin: "0px 4px" }} className="btn btn-default" data-bs-dismiss="modal">Close</button>
                                        <button onClick={handleAddJunction} style={{ margin: "0px 4px" }} className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Eductor Selection Modal */}
                        <div className="modal" tabIndex="-1"
                            id="eductorResults" role="dialog" aria-labelledby="copyDesignLabel" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div className="modal-dialog" style={{ display: "flex", flexDirection: "column", justifyContent: "center", margin: "auto", alignItems: "center", minWidth: "90vw", marginTop: "5vh" }}>
                                <div className="modal-content" style={{ border: "1px solid var(--bs-primary)", boxShadow: "4px 4px 4px 0px gray", width: "900px", height: "90vh" }}>
                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addComponentLabel">Compatible Eductors for this configuration</h4></div>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>

                                    </div>

                                    <div className="modal-body" style={{ overflowY: "auto", height: "100%", padding: "24px" }}>
                                        {/* <label>ⓘ Compatible Eductors</label> */}
                                        <br />
                                        <div id="eductorResultsForm" noValidate="noValidate" autoComplete="off" style={{ marginBottom: "32px" }}>

                                            <div style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
                                                <div style={{ width: "15%" }}>
                                                    <label htmlFor="eductorSystemInlet" className="form-label">Inlet</label>
                                                    <input
                                                        id="eductorSystemInlet"
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        step="any"
                                                        value={eductorInlet}
                                                        onChange={(e) => setEductorInlet(e.target.value)}
                                                    />
                                                </div>
                                                <div style={{ width: "15%" }}>
                                                    <label htmlFor="eductorSystemOutlet" className="form-label">Outlet</label>
                                                    <input
                                                        id="eductorSystemOutlet"
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        step="any"
                                                        value={eductorOutlet}
                                                        onChange={(e) => setEductorOutlet(e.target.value)}
                                                    />
                                                </div>
                                                <div style={{ width: "50%" }}>
                                                    <label htmlFor="eductorSearch" className="form-label">Search Eductors</label>
                                                    <input
                                                        id="eductorSearch"
                                                        className="form-control"
                                                        type="search"
                                                        placeholder="Search by model, fan model, or fit..."
                                                        value={eductorSearch}
                                                        onChange={(e) => setEductorSearch(e.target.value)}
                                                    />
                                                </div>
                                                <div style={{ width: "128px", alignSelf: "end" }}>
                                                    <button className="btn btn-primary" type="button" onClick={() => fetchEductorMatches()}>
                                                        Update Results
                                                    </button>
                                                </div>
                                            </div>

                                            {eductorMatches.length == 0 && (
                                                <div style={{ marginBottom: "16px" }}>
                                                    ⓘ There are no compatible eductors found for this configuration as specified:
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontWeight: "bold", marginLeft: "-16px" }}>
                                                        <span>Inlet: {Math.ceil(parseFloat(eductorInfo["inletDiameter"]))}"</span>
                                                        <span>Outlet: {Math.ceil(parseFloat(eductorInfo["outletDiameter"]))}"</span>
                                                    </div>


                                                    <br />
                                                    <br />
                                                    (An exact match has a matching inlet and outlet diameter.)
                                                    <br />
                                                    (An approximate match must be within (+1") on inlet side and within (±2") on outlet side.)

                                                </div>
                                            )

                                            }

                                            {eductorMatches.length > 0 && configuration != undefined &&
                                                <>
                                                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "4px" }}>
                                                        <span style={{ fontSize: "12px", color: "var(--bs-secondary)" }}>
                                                            {filteredEductorMatches.length} {filteredEductorMatches.length === 1 ? "result" : "results"}
                                                        </span>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-hover" style={{ marginBottom: "0" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: "25%" }}>Model</th>
                                                                    <th style={{ width: "37.5%" }}>Fan Model</th>
                                                                    <th style={{ width: "15%" }}>Fit</th>
                                                                    <th style={{ width: "22.5%" }}>Details</th>
                                                                </tr>
                                                            </thead>
                                                        </table>
                                                    </div>
                                                    <div className="accordion" id="eductorAccordion">
                                                        {filteredEductorMatches.map((ed) => (
                                                            <div className="accordion-item" key={ed.id}>
                                                                <h2 className="accordion-header" id={`eductorHeader${ed.id}`} style={{ marginTop: "4px" }}>
                                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#eductorCollapse${ed.id}`} aria-expanded="false" aria-controls={`eductorCollapse${ed.id}`}
                                                                        style={{
                                                                            backgroundColor: "var(--bs-light)",
                                                                            border: "1px solid var(--bs-primary)",
                                                                            borderRadius: "4px",
                                                                            padding: "8px",
                                                                            marginBottom: "0px",   // <- reduce spacing
                                                                            height: "48px"
                                                                        }}

                                                                    >
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center" }}>

                                                                            <div style={{ width: "25%" }}>
                                                                                <span style={{ fontWeight: "bold", fontSize: "16px" }}>{ed.model}</span>
                                                                            </div>
                                                                            <div style={{ width: "37.5%", display: "flex", justifyContent: "flex-start" }}>
                                                                                <span style={{ fontWeight: "bold", fontSize: "16px" }}>{ed.bspr_manufacturermodel}</span>
                                                                            </div>
                                                                            <div style={{ width: "15%", display: "flex", justifyContent: "flex-start" }}>
                                                                                <span style={{ fontSize: "16px", color: ed.ExactResult === "Exact" ? "var(--bs-success)" : "var(--bs-danger)" }}>{ed.ExactResult} Fit</span>
                                                                            </div>
                                                                            <div style={{ width: "22.5%", textAlign: "right", paddingRight: "24px" }}>
                                                                                View details
                                                                            </div>

                                                                        </div>
                                                                    </button>
                                                                </h2>

                                                                <div id={`eductorCollapse${ed.id}`} className="accordion-collapse collapse" aria-labelledby={`eductorHeader${ed.id}`} data-bs-parent="#eductorAccordion">
                                                                    <div className="accordion-body">
                                                                        <ul className="nav nav-tabs" role="tablist">
                                                                            <li className="nav-item" role="presentation">
                                                                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target={`#eductorTests${ed.id}`} type="button" role="tab">Test Values</button>
                                                                            </li>
                                                                            <li className="nav-item" role="presentation">
                                                                                <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#eductorDetails${ed.id}`} type="button" role="tab">Eductor Details</button>
                                                                            </li>
                                                                            <li className="nav-item" role="presentation">
                                                                                <button className="nav-link" data-bs-toggle="tab" data-bs-target={`#eductorPerformance${ed.id}`} type="button" role="tab">Performance</button>
                                                                            </li>
                                                                        </ul>
                                                                        <div className="tab-content" style={{ paddingTop: "16px" }}>
                                                                        <div className="tab-pane fade show active" id={`eductorTests${ed.id}`} role="tabpanel">

                                                                        <div style={{ width: "66%", display: "flex", justifyContent: "center", margin: "4px auto" }}>
                                                                            <PerformanceGraphDE input={ed.tests} eductor={ed} config={configuration} />
                                                                        </div>

                                                                        {ed.tests?.length > 0 && (
                                                                            <div style={{ marginTop: "20px" }}>
                                                                                <strong>Eductor Test Values:</strong>
                                                                                <div className="table-responsive" style={{ marginTop: "8px" }}>
                                                                                    <table className="table table-sm table-bordered table-striped" style={{ fontSize: "13px", marginBottom: 0 }}>
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>% Open</th>
                                                                                                <th>Location</th>
                                                                                                <th>Diameter</th>
                                                                                                <th>SP</th>
                                                                                                <th>VP Readings</th>
                                                                                                <th>Avg √VP</th>
                                                                                                <th>Velocity</th>
                                                                                                <th>CFM</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {ed.tests.map((test) => (
                                                                                                <tr key={test.index}>
                                                                                                    <td>{test.percentage}%</td>
                                                                                                    <td>{String(test.inletoutlet) === "0" ? "Inlet" : "Outlet"}</td>
                                                                                                    <td>{test.diameter}"</td>
                                                                                                    <td>{test.staticpressure}</td>
                                                                                                    <td style={{ whiteSpace: "nowrap" }}>
                                                                                                        {[...Array(11)].map((_, vpIndex) => test[`vp${vpIndex + 1}`]).filter((value) => value !== "" && value != 0).join(", ") || "-"}
                                                                                                    </td>
                                                                                                    <td>{test.average}</td>
                                                                                                    <td>{test.velocity}</td>
                                                                                                    <td>{test.cfm}</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        </div>

                                                                        <div className="tab-pane fade" id={`eductorDetails${ed.id}`} role="tabpanel">

                                                                        <div style={{ marginTop: "16px" }}>
                                                                            <strong>Eductor Details:</strong>
                                                                            <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse", fontSize: "14px" }}>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", width: "30%", color: "var(--bs-primary)" }}>Model</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.model}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", color: "var(--bs-primary)" }}>Fan Model</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.bspr_manufacturermodel}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", color: "var(--bs-primary)" }}>Job #</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.jobnumber}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", color: "var(--bs-primary)" }}>Sketch #</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.sketchnumber || "-"}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", color: "var(--bs-primary)" }}>Internal PO</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.bspr_purchaseordernumber || "-"}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", color: "var(--bs-primary)" }}>Date Created</td>
                                                                                        <td style={{ padding: "4px 8px", color: "var(--bs-dark)" }}>{ed.datecreated || "-"}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                        <hr />

                                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                                                                            <div style={{ flex: 1 }}><strong>Inlet:</strong> {ed.inletdiameter}"</div>
                                                                            <div style={{ flex: 1 }}><strong>Outlet:</strong> {ed.outletdiameter}"</div>
                                                                            <div style={{ flex: 1 }}><strong>Horsepower:</strong> {ed.horsepower}</div>
                                                                            <div style={{ flex: 1 }}><strong>Frequency:</strong> {ed.frequency} Hz</div>
                                                                            <div style={{ flex: 1 }}><strong>Rated Amps:</strong> {ed.apr_motorampsrated}</div>
                                                                        </div>
                                                                        </div>

                                                                        <div className="tab-pane fade" id={`eductorPerformance${ed.id}`} role="tabpanel">
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "98%", margin: "1%" }}>

                                                                            {/* CSPR */}
                                                                            <div style={{ width: "50%" }}>
                                                                                <strong style={{ color: "var(--bs-primary)" }}>Calculated System Performance:</strong>
                                                                                <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse" }}>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px", width: "30%" }}>Induced Airflow</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.cspr_inducedairflow}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Inlet SP</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.cspr_inletstaticpressure}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Discharge SP</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.cspr_dischargestaticpressure}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>

                                                                            {/* BSPR */}
                                                                            <div style={{ width: "50%" }}>
                                                                                <strong style={{ color: "var(--bs-primary)" }}>Blower Selection Performance Requirements:</strong>
                                                                                <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse" }}>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px", width: "30%" }}>Airflow (ACFM)</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.bspr_airflowcfm}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Inlet SP</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.bspr_inletstaticpressure}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Outlet SP</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.bspr_outletstaticpressure}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Calculated BHP</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.bspr_calculatedbhp}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Date Completed</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.bspr_datecompleted}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "98%", margin: "1%" }}>

                                                                            {/* APR */}
                                                                            <div style={{ width: "50%" }}>
                                                                                <strong style={{ color: "var(--bs-primary)" }}>Actual Performance Results:</strong>
                                                                                <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse" }}>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px", width: "30%" }}>Plenum Pressure</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_plenumpressure}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Nozzle Setting</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_nozzlesetting}"</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Static Closed Off</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_staticclosedoff}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Tight / Loose</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_tight}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Motor RPM</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motorrpm}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Motor Voltage</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motorvoltage}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Intake Silencer</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.intakesilencer == 1 ? 'Yes' : 'No'}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Calculated ACFM</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_calculatedblowerairflow}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Plenum Type</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_plenumtype}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>

                                                                            <hr />

                                                                            {/* Motor */}
                                                                            <div style={{ width: "50%" }}>
                                                                                <strong style={{ color: "var(--bs-primary)" }}>Motor Amps:</strong>
                                                                                <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse" }}>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px", width: "25%" }}>1</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motoramps1}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>2</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motoramps2}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>3</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motoramps3}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Average</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motorampsaverage}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Rated</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motorampsrated}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Motor Notes</td>
                                                                                            <td style={{ padding: "4px 8px" }}>{ed.apr_motornotes}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>

                                                                        </div>

                                                                        <hr />

                                                                        <div>
                                                                            <strong style={{ color: "var(--bs-primary)" }}>Air Properties:</strong>
                                                                            <table style={{ width: "100%", marginTop: "8px", borderCollapse: "collapse" }}>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px", width: "30%" }}>Temperature</td>
                                                                                        <td style={{ padding: "4px 8px" }}>{ed.air_temperature} °F</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Humidity</td>
                                                                                        <td style={{ padding: "4px 8px" }}>{ed.air_humidity}%</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Pressure</td>
                                                                                        <td style={{ padding: "4px 8px" }}>{ed.air_pressure} inHg</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                        {ed.notes && (
                                                                            <>
                                                                                <hr />
                                                                                <div><strong>Notes:</strong> {ed.notes}</div>
                                                                            </>
                                                                        )}
                                                                        </div>
                                                                        </div>

                                                                        <div style={{ display: "flex", justifyContent: "center", margin: "16px" }}>
                                                                            <button onClick={(e) => handleAttachEductor(e, ed.id)} className="btn btn-success" style={{ width: "100%", color: "var(--bs-dark)" }}>
                                                                                Attach this eductor (<i>{ed.model}</i>) to this Design

                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {filteredEductorMatches.length === 0 && (
                                                        <div className="text-center text-muted" style={{ padding: "16px" }}>
                                                            No eductors match your search.
                                                        </div>
                                                    )}
                                                </>
                                            }

                                        </div>

                                        <button onClick={clearElements} type="button" style={{ margin: "0px 4px" }} className="btn btn-default" data-bs-dismiss="modal">Close</button>

                                        <button className="btn btn-primary" onClick={() => { navigate("/Eductor") }} data-bs-dismiss="modal" style={{ marginRight: "32px" }}>Browse All Eductors</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Copy Design Modal */}
                        <div className="modal" id="copyDesign" tabIndex="-1" role="dialog" aria-labelledby="copyDesignLabel" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div className="modal-dialog" role="document" >
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: "24px" }}>
                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}><span aria-hidden="true">×</span></button>
                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addJunctionLabel">Copy Design</h4></div>
                                    </div>

                                    <div className="modal-body">
                                        <label>ⓘ Copy nodes from this design to another folder as a new design.</label>
                                        <br />
                                        <form id="copyDesignForm" noValidate="noValidate" autoComplete="off">

                                            <div className="form-inline" style={{ marginBottom: "10px" }}>
                                                <label style={{ width: "125px" }}>Copy Up to node...</label>
                                                <select id="CopyToDesignComponentId" className="form-control" style={{ minWidth: "225px", maxWidth: "550px", marginLeft: "10px" }}>
                                                    <option value="">Select Node</option>
                                                    {configuration["Components"] &&
                                                        configuration["Components"].map((n, i4) => (
                                                            <option key={i4} value={parseInt(n["Item"])}>{`Item ${n["Item"]} - ${n["Type"]} (${n["Component"]})`}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>

                                            <div className="form-inline" style={{ marginBottom: "10px" }}>
                                                <label style={{ width: "125px" }}>to Folder...</label>
                                                <select id="CopyToDesignFolderId" className="form-control" style={{ minWidth: "225px", maxWidth: "550px", marginLeft: "10px" }}>
                                                    <option value="">Select Project</option>
                                                    {designProjectsList &&
                                                        designProjectsList.map((d, i5) => (
                                                            <option key={i5} value={d["designid"]}>{`${d["designnum"]} (${d["company"]})`}</option>
                                                        ))
                                                    }

                                                </select>
                                            </div>

                                        </form>
                                        <button onClick={clearElements} type="button" style={{ margin: "0px 4px" }} className="btn btn-default" data-bs-dismiss="modal">Close</button>
                                        <button onClick={handleCopy} className="btn btn-primary" style={{ marginLeft: "15px" }} data-bs-dismiss="modal">Copy</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* New Node Modal */}
                        <div className="modal" id="newNode" tabIndex="-1" role="dialog" aria-labelledby="addNodeLabel" data-bs-keyboard="false" data-bs-backdrop="static">

                            <div className="modal-dialog" role="document">

                                <div className="modal-content">

                                    <div className="modal-header" style={{ padding: "24px" }}>

                                        <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", margin: "0px 4px" }}>
                                            <span aria-hidden="true">×</span></button>

                                        <div style={{ position: "absolute", left: "8px", top: "12px", marginLeft: "8px" }}><h4 className="modal-title" id="addNodeLabel">Add Node</h4></div>
                                    </div>

                                    <div className="modal-body">

                                        <form id="newNodeForm" noValidate="noValidate" autoComplete="off">
                                            <div className="form-group">Node Number (number only)
                                                <input type="number" min="0" className="form-control" id="NodeNumber" name="NodeNumber" autoComplete="off" />
                                            </div>
                                        </form>
                                        <button onClick={clearElements} type="button" style={{ margin: "0px 4px" }} className="btn btn-default" data-bs-dismiss="modal">Close</button>
                                        <button onClick={handleAddNode} style={{ margin: "0px 4px" }} className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {isChopperSelectModalOpen && (
                            <ChopperSelectionModal
                                onClose={() => setIsChopperSelectModalOpen(false)}
                                onSubmit={handleAssignChopper}
                                componentID={selectedChopperComponentID}
                            />
                        )}

                    </div>
                </>
            }

            {user["email"] == undefined && <LoginRedirect />}
        </div >

    );
}

export default DesignEdit;
